<template>
  <div class="language-switch">
    <slot />
  </div>
</template>

<style lang="scss">
@import "../scss/importall.scss";

.language-switch {
  @extend %text;

  .language-switch-link {
    color: inherit;
    text-decoration: none;
    transition: all 0.15s ease-in-out;
    border-bottom: 0.1rem solid transparent;

    &:hover {
      border-color: currentColor;
    }
  }
}
</style>
